export const modalConstants = {
  LOGIN_TOGGLE: 'LOGIN_TOGGLE',
  ADVANCE_SEARCH_TOGGLE: 'ADVANCE_SEARCH_TOGGLE',
  KONFIGURASI_UNDUH_TOGGLE: 'KONFIGURASI_UNDUH_TOGGLE',
  NARAPIDANA_SEARCH_TOGGLE: 'NARAPIDANA_SEARCH_TOGGLE',
  PUTUSAN_SEARCH_TOGGLE: 'PUTUSAN_SEARCH_TOGGLE',
  REPORT_TOGGLE: 'REPORT_TOGGLE',
}
